import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            clipRule="evenodd"
            d="M4 3C4 2.44772 4.44772 2 5 2H8V4C8 5.10457 8.89543 6 10 6H12V7.5C12 7.77614 12.2239 8 12.5 8C12.7761 8 13 7.77614 13 7.5V5.5V5.12132C13 4.59089 12.7893 4.08218 12.4142 3.70711L11.3536 2.64645L10.2929 1.58579C9.91782 1.21071 9.40911 1 8.87868 1H8.5H5C3.89543 1 3 1.89543 3 3V13C3 14.1046 3.89543 15 5 15H7C7.27614 15 7.5 14.7761 7.5 14.5C7.5 14.2239 7.27614 14 7 14H5C4.44772 14 4 13.5523 4 13V3ZM9 2.00738V4C9 4.55228 9.44772 5 10 5H11.9926C11.9657 4.77949 11.8658 4.57293 11.7071 4.41421L12.0607 4.06066L11.7071 4.41421L10.6464 3.35355L9.58579 2.29289C9.42707 2.13418 9.22051 2.03433 9 2.00738Z"
            fill="currentColor"
            fillRule="evenodd"
        />
        <path
            clipRule="evenodd"
            d="M12.016 13.7231C11.7182 13.899 11.3709 14 11 14C9.89543 14 9 13.1046 9 12C9 11.6291 9.10096 11.2818 9.27691 10.984L12.016 13.7231ZM12.7231 13.016L9.98402 10.2769C10.2818 10.101 10.6291 10 11 10C12.1046 10 13 10.8954 13 12C13 12.3709 12.899 12.7182 12.7231 13.016ZM14 12C14 13.6569 12.6569 15 11 15C9.34315 15 8 13.6569 8 12C8 10.3431 9.34315 9 11 9C12.6569 9 14 10.3431 14 12Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export default Icon;
